import React from 'react';
import { Box } from '@blueprint/ui';

export const LabelBox = ({ children }) => {
    return <Box marginTop={['5px', '5px', '5px', '31px']}>{children}</Box>;
};
